import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import Imagic from "../../../../components/imagic/imagic";
import { Product } from "../../../../models/product-list";
import { SearchResponseBody } from "../../../../models/search-response";
import { API } from "../../../../services/api-services";
import { ROUTES } from "../../../../services/router-services";
import { _c } from "../../../../services/text-services";
import FetchData from "../../../shared/fetch-data/fetch-data";
import styles from "./list.module.scss";

interface List2Props {
  products: Product[];
  loadMoreProduct: () => void;
  showLoadMore: boolean;
  limit: number;
  keyword?: string | string[];
}

export function List2({
  products,
  loadMoreProduct,
  showLoadMore,
  limit,
  keyword
}: List2Props) {
  const [
    searchResponseBody,
    setSearchResponseBody
  ] = useState<SearchResponseBody>();
  const postUserResponse = (productId: number, position: number) => {
    if (!!keyword)
      setSearchResponseBody({
        product_id: productId,
        keyword: keyword,
        position: position
      });
  };


  return (
    <>
      {!!searchResponseBody && (
        <FetchData
          url={API.request_search_response}
          method="POST"
          body={JSON.stringify(searchResponseBody)}
          counter={searchResponseBody.product_id}
        />
      )}
      <div className="d-flex flex-wrap">
        {products &&
          products.slice(0, limit).map((product, i) => (
            <div
              className="col-4 col-md-3 col-lg-2 mb-4"
              key={`cat-${i}`}
              onClick={() => {
                postUserResponse(product.id, i);
              }}
            >
              <Link 
                prefetch={false}  
                href={ROUTES.product(product)}>
                <a className="mb-2">
                  {product?.avatar?.hdpi && <Imagic
                    width={192}
                    height={277}
                    src={product.avatar.hdpi}
                    alt={product.name || "no-product-name"}
                  />}
                  <p className={_c(styles, "title")}>{product.name}</p>
                </a>
              </Link>
            </div>
          ))}
      </div>
      {/*<!-- load more -->*/}
      {showLoadMore && (
        <div
          onClick={() => loadMoreProduct()}
          className={_c(styles, "mt-4 mb-4 more-text")}
        >
          <span>مشاهده بیشتر</span>
          <div className={_c(styles, "more")}></div>
        </div>
      )}
    </>
  );
}

export default List2;
